import React, { Suspense, lazy } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import HeroCallbackForm from "@/components/HeroCallbackForm";
import Footer from "@/components/Footer";
import FixedCTA, { FloatingWhatsApp, FloatingApply } from "@/components/FixedCTA";
import FadeInSection from "@/components/FadeInSection";

// Lazy load below-fold sections — not needed for initial render
const TajRambaghSection = lazy(() => import("@/components/TajRambaghSection"));
const OberoiSection = lazy(() => import("@/components/OberoiSection"));
const StatsSection = lazy(() => import("@/components/StatsSection"));
const CoursesSection = lazy(() => import("@/components/CoursesSection"));
const WhyChooseUs = lazy(() => import("@/components/WhyChooseUs"));
const PlacementVideosSection = lazy(() => import("@/components/PlacementVideosSection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const EnquiryForm = lazy(() => import("@/components/EnquiryForm"));
const RequestCallback = lazy(() => import("@/components/RequestCallback"));

// Minimal placeholder while lazy sections load
const SectionPlaceholder = () => (
  <div className="min-h-[200px]" />
);

const LandingPage = () => {
  return (
    <div className="relative">
      <Navbar />
      <main>
        {/* Hero loads immediately - above the fold */}
        <HeroSection />
        <HeroCallbackForm />
        
        {/* Below-fold sections: lazy loaded + fade in on scroll */}
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <TajRambaghSection />
          </FadeInSection>
        </Suspense>
        
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <OberoiSection />
          </FadeInSection>
        </Suspense>
        
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <RequestCallback sectionId="callback-after-oberoi" />
          </FadeInSection>
        </Suspense>
        
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <StatsSection />
          </FadeInSection>
        </Suspense>
        
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <CoursesSection />
          </FadeInSection>
        </Suspense>
        
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <RequestCallback sectionId="callback-after-courses" />
          </FadeInSection>
        </Suspense>
        
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <WhyChooseUs />
          </FadeInSection>
        </Suspense>
        
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <PlacementVideosSection />
          </FadeInSection>
        </Suspense>
        
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <TestimonialsSection />
          </FadeInSection>
        </Suspense>
        
        <Suspense fallback={<SectionPlaceholder />}>
          <FadeInSection>
            <EnquiryForm />
          </FadeInSection>
        </Suspense>
      </main>
      <Footer />
      <FixedCTA />
      <FloatingWhatsApp />
      <FloatingApply />
    </div>
  );
};

export default LandingPage;
